// NOTE: previously handling of places was here but it was moved to google components because it causes inaccuracy

import { Box, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";

import { Autocomplete } from "@react-google-maps/api";
import { colors } from "common";
import SearchIcon from "@mui/icons-material/Search";

// ==============================================================
type Props = {
  hidden?: boolean;
  inputValue?: string;
  onPlaceChanged: () => void;
  setInputValue: (v: string) => void;
  onLoad: (autoCompleteRef: google.maps.places.Autocomplete) => void;
  autoCompleteBounds?:
    | google.maps.LatLngBounds
    | google.maps.LatLngBoundsLiteral;
};
// ==============================================================

const MapAutoComplete = ({
  inputValue,
  hidden = false,
  onLoad,
  setInputValue,
  onPlaceChanged,
  autoCompleteBounds = undefined,
}: Props) => {
  const [_searchBoxInternalRef, setSearchBoxInternalRef] = useState<
    google.maps.places.Autocomplete | undefined
  >();

  const onPlaceChangedInternal = () => {
    onPlaceChanged();
  };

  const onLoadInternal = (newSearchBoxRef: google.maps.places.Autocomplete) => {
    onLoad(newSearchBoxRef);
    setSearchBoxInternalRef(newSearchBoxRef);
  };

  return (
    <Box hidden={hidden}>
      <Autocomplete
        onLoad={onLoadInternal}
        restrictions={{ country: "PH" }}
        bounds={autoCompleteBounds}
        fields={["geometry", "formatted_address"]}
        onPlaceChanged={onPlaceChangedInternal}
      >
        <TextField
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          color="info"
          variant="outlined"
          placeholder="Search location"
          size="small"
          sx={{
            padding: 1,
            borderRadius: 2,
            position: "absolute",
            top: 4,
            left: 4,
            right: 4,
            backgroundColor: colors.primary,
          }}
          InputProps={{
            sx: { backgroundColor: colors.common.white },
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Autocomplete>
    </Box>
  );
};

export default MapAutoComplete;
